import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatIconModule,
  MatDialogModule,
  MatButtonModule,
  MatSidenavModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatInputModule,
} from '@angular/material';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { RequestInterceptor } from './services/api/request-interceptor.service';
import { AppCommonModule } from './common-modules/common.module';
import { LoginComponent } from './pages/login/login.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { AuthGuard } from './guard/auth.guard';
import { CoreModule } from './state/core.module';
import { LoadingService } from './services/loading.service';
import { PortalComponent } from './pages/portal/portal.component';
import { StockTriage } from './function-modules/stock-triage/pages/stock-triage/stock-triage.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PageNotFoundComponent,
    PortalComponent,
    StockTriage,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    CoreModule,
    AppRoutingModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatSidenavModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    AppCommonModule,
  ],
  providers: [
    AuthGuard,
    LoadingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
